export enum BasketballOperationsCenterConflictSeverityEnum {
  ORANGE = 1,
  RED = 2,
}
